import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';

type NoAvailabilityModalProps = {
  onBackToHome?: () => void;
};

export const NoAvailabilityModal: React.ForwardRefExoticComponent<
  NoAvailabilityModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ onBackToHome }, forwardedRef) => {
  const [t] = useLanguage();
  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  return (
    <Modal ref={modalRef}>
      <h3 className="modal-title">
        {t('noAvailableTimePickerSlotModal.title')}
      </h3>
      <p className="modal-description">
        {t('noAvailableTimePickerSlotModal.description')}
      </p>
      <div className="modal-button-container">
        <Button
          onClick={onBackToHome}
          label={t('noAvailableTimePickerSlotModal.backToHome')}
        />
      </div>
    </Modal>
  );
});
